<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>{{'help.browsers.title.shortLabel' | translate}}</h2>
        </mat-card-title>
        <mat-card-subtitle>{{'help.browsers.title.summary' | translate}}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
        <mat-list dense>
            <mat-list-item>
                <fa-icon class="list-icon" matListIcon [icon]="['fab', 'chrome']"></fa-icon>
                <p matLine>Google Chrome: 71.0</p>
            </mat-list-item>
            <mat-list-item>
                <fa-icon class="list-icon" matListIcon [icon]="['fab', 'firefox']"></fa-icon>
                <p matLine>Mozilla Firefox: 64.0</p>
            </mat-list-item>
            <mat-list-item>
                <fa-icon class="list-icon" matListIcon [icon]="['fab', 'safari']"></fa-icon>
                <p matLine>Safari: 11.1.1</p>
            </mat-list-item>
            <mat-list-item>
                <fa-icon class="list-icon" matListIcon [icon]="['fab', 'edge']"></fa-icon>
                <p matLine>Microsoft Edge: 17.17134</p>
            </mat-list-item>
            <mat-list-item>
                <fa-icon class="list-icon" matListIcon [icon]="['fab', 'internet-explorer']"></fa-icon>
                <p matLine>Internet Explorer: {{'help.browsers.notSupported.shortLabel' | translate}}</p>
            </mat-list-item>
        </mat-list>

        <div [innerHTML]="'help.browsers.title.detail' | translate"></div>
    </mat-card-content>
</mat-card>
